import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: "idle",
  isZoomedIn: false,
};

export const setMapZoomedIn = createAsyncThunk(
  "map/setMapZoomedIn",
  async ({ video }) => {    
    return { video };
  }
);

export const clearMapZoomedIn = createAsyncThunk(
  "map/clearMapZoomedIn",
  async () => {
    return;
  }
);

export const clearMapAsync = createAsyncThunk(
  "map/clearMapAsync",
  async () => {
    return;
  }
);

export const mapSlice = createSlice({
  name: "map",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(setMapZoomedIn.pending, (state) => {
        state.status = `loading`;
      })
      .addCase(setMapZoomedIn.fulfilled, (state, { payload }) => {
        const { video } = payload;        

        state.isZoomedIn = true;
        state.isZoomedInOn = video.learningPathId;
        state.transformOrigin = video.ui.position;
        state.status = `idle`;
      })
      .addCase(clearMapZoomedIn.pending, (state) => {
        state.status = `loading`;
      })
      .addCase(clearMapZoomedIn.fulfilled, (state) => {        
        state.isZoomedIn = false;
        state.isZoomedInOn = undefined;
        state.transformOrigin = undefined;
        state.status = `idle`;
      })
      .addCase(clearMapAsync.pending, (state) => {
        state.status = `loading`;
      })
      .addCase(clearMapAsync.fulfilled, (state) => {        
        state.isZoomedIn = false;
        state.isZoomedInOn = undefined;
        state.transformOrigin = undefined;
        state.status = `idle`;
      });
  },
});

export default mapSlice.reducer;
